import React from 'react';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import Image from '../../../Image';
import Text from '../../../Text';

const Card = styled.div`
  width: 100%;
`;

const Icon = styled.div`
  width: 12px;
  height: 12px;
  ${({ theme }) => theme.breakpoint('md')} {
    width: 24px;
    height: 24px;
  }
  margin-right: 8px;
  display: grid;
  place-items: center;
`;

const Row = styled.div`
  height: 24px;
  margin-bottom: 4px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
`;

const CardDescription = ({ icon, listDescriptions, id }) => {
  const { t } = useTranslation();

  return (
    <Card id={id}>
      {listDescriptions.map((description, key) => (
        <Row key={key}>
          <Icon>
            <Image src={icon} />
          </Icon>
          <Text style={{ margin: '2' }} type="Caption-w400" color="gray700">
            {t(description)}
          </Text>
        </Row>
      ))}
    </Card>
  );
};

export default CardDescription;
